import { render } from "./Index_m.vue?vue&type=template&id=bb04d4ce"
import script from "./Index_m.vue?vue&type=script&lang=js"
export * from "./Index_m.vue?vue&type=script&lang=js"

import "./Index_m.vue?vue&type=style&index=0&id=bb04d4ce&lang=css"
script.render = render

export default script